
import React, { useEffect, useState, useRef, useCallback } from "react";
import { Link, useParams } from "react-router-dom";
import { useSelector } from "react-redux";
import Axios from "axios";
import AkkhorLayout from "../layout/akkhor";
import { URL_LIST_ALL } from "../configs/api";
import { confirmAlert } from "react-confirm-alert";
import Spinner from "../component/Spinner";
import CauHoiRenderer from "./CauHoiRenderer";

export default function LamBaiThi() {
    const { id } = useParams(); // dethi_id
    const { user } = useSelector((state) => state.auth);
    const [dethi, setDethi] = useState(null);
    const [loading, setLoading] = useState(false);
    const [answers, setAnswers] = useState({}); // { cauhoi_id: tra_loi }
    const [submitting, setSubmitting] = useState(false);
    const [secondsLeft, setSecondsLeft] = useState(null);
    const [savedAt, setSavedAt] = useState(null); // mốc autosave gần nhất (hiển thị)
    const timeStartRef = useRef(null);   // mốc bắt đầu theo giờ server
    const submittedRef = useRef(false);
    const readyRef = useRef(false);      // chỉ autosave sau khi đã load + khôi phục xong
    const saveTimerRef = useRef(null);

    const draftKey = "lambai_draft_" + (user.data && user.data.id) + "_" + id;

    useEffect(() => {
        if (!(id > 0)) return;
        setLoading(true);
        Axios.get(URL_LIST_ALL + "learninghub_lambai?dethi_id=" + id, user.config)
            .then((res) => {
                setLoading(false);
                if (res.data.status !== "success") {
                    confirmAlert({ title: 'Lỗi', message: res.data.message, buttons: [{ label: 'OK' }] });
                    return;
                }
                const d = res.data.data;
                setDethi(d);
                if (d.time_start) timeStartRef.current = d.time_start;

                // ===== Khôi phục bài nháp: server trước, localStorage đè lên (mới nhất trên máy này) =====
                let restored = {};
                if (d.tra_loi_nhap && typeof d.tra_loi_nhap === 'object') restored = { ...d.tra_loi_nhap };
                try {
                    const local = JSON.parse(window.localStorage.getItem(draftKey) || 'null');
                    if (local && local.answers) restored = { ...restored, ...local.answers };
                } catch (e) { /* ignore */ }
                setAnswers(restored);

                // ===== Đồng hồ tính tiếp theo time_start server =====
                if (d.thoi_gian && d.time_start) {
                    const serverNow = res.data.time || Math.floor(Date.now() / 1000);
                    const elapsed = serverNow - d.time_start;
                    const left = d.thoi_gian * 60 - elapsed;
                    setSecondsLeft(left > 0 ? left : 0);
                }
                // Cho phép autosave sau tick này
                setTimeout(() => { readyRef.current = true; }, 0);
            })
            .catch((err) => { console.log(err); setLoading(false); });
    }, [user, id]);// eslint-disable-line

    // Đếm ngược (anchored server time, reload không reset)
    useEffect(() => {
        if (secondsLeft === null) return;
        if (secondsLeft <= 0) { doSubmit(true); return; }
        const t = setTimeout(() => setSecondsLeft(secondsLeft - 1), 1000);
        return () => clearTimeout(t);
    }, [secondsLeft]);// eslint-disable-line

    // Gửi nháp lên server (debounced)
    const serverSaveDraft = useCallback((ans) => {
        Axios.post(URL_LIST_ALL + "learninghub_bailam_nhap", { dethi_id: Number(id), answers: ans }, user.config)
            .then((res) => { if (res.data.status === "success") setSavedAt(Date.now()); })
            .catch((err) => console.log(err)); // mất mạng: localStorage vẫn giữ
    }, [id, user]);

    // Autosave mỗi khi answers đổi: localStorage ngay + server debounce 4s
    useEffect(() => {
        if (!readyRef.current || submittedRef.current) return;
        try { window.localStorage.setItem(draftKey, JSON.stringify({ answers, savedAt: Date.now() })); } catch (e) { /* ignore */ }
        if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
        saveTimerRef.current = setTimeout(() => serverSaveDraft(answers), 4000);
        return () => { if (saveTimerRef.current) clearTimeout(saveTimerRef.current); };
    }, [answers]);// eslint-disable-line

    const setAnswer = (cauhoi_id, val) => setAnswers((prev) => ({ ...prev, [cauhoi_id]: val }));

    const doSubmit = (auto = false) => {
        if (submittedRef.current) return;
        const send = () => {
            submittedRef.current = true;
            if (saveTimerRef.current) clearTimeout(saveTimerRef.current);
            setSubmitting(true);
            const payload = {
                dethi_id: Number(id),
                time_start: timeStartRef.current,
                answers: (dethi.list_cauhoi || []).map((c) => ({
                    cauhoi_id: c.cauhoi_id,
                    tra_loi: answers[c.cauhoi_id] !== undefined ? answers[c.cauhoi_id] : null,
                })),
            };
            Axios.post(URL_LIST_ALL + "learninghub_bailam", payload, user.config)
                .then((res) => {
                    setSubmitting(false);
                    if (res.data.status === "success") {
                        try { window.localStorage.removeItem(draftKey); } catch (e) { /* ignore */ }
                        window.location.href = "/ket-qua-bai-lam/" + res.data.id;
                    } else {
                        submittedRef.current = false;
                        confirmAlert({ title: 'Lỗi', message: res.data.message, buttons: [{ label: 'OK' }] });
                    }
                })
                .catch((err) => { console.log(err); setSubmitting(false); submittedRef.current = false; });
        };
        if (auto) { send(); return; }
        confirmAlert({
            title: 'Xác nhận nộp bài',
            message: 'Bạn chắc chắn muốn nộp bài?',
            buttons: [{ label: 'Nộp bài', onClick: send }, { label: 'Hủy' }],
        });
    };

    const fmtTime = (s) => {
        const m = Math.floor(s / 60), ss = s % 60;
        return `${m}:${ss < 10 ? '0' : ''}${ss}`;
    };
    const fmtSavedAt = (ts) => {
        const d = new Date(ts);
        return `${d.getHours()}:${String(d.getMinutes()).padStart(2, '0')}:${String(d.getSeconds()).padStart(2, '0')}`;
    };

    return (
        <AkkhorLayout idrole="dashboard">
            <div className="breadcrumbs-area">
                <ul>
                    <li><Link to="/">Trang chủ</Link></li>
                    <li><Link to="/bai-kiem-tra">Bài kiểm tra</Link></li>
                    <li>{dethi && dethi.title}</li>
                </ul>
            </div>
            {loading && <div className="w-100 text-center"><Spinner /></div>}
            {dethi &&
                <div className="card height-auto mt-2">
                    <div className="card-body">
                        <div className="d-flex justify-content-between align-items-center">
                            <h3>{dethi.title}</h3>
                            {secondsLeft !== null &&
                                <span className={"badge " + (secondsLeft < 60 ? "badge-danger" : "badge-info")} style={{ fontSize: 18 }}>
                                    <span className="far fa-clock"></span> {fmtTime(secondsLeft)}
                                </span>}
                        </div>
                        {dethi.mota && <p className="text-muted">{dethi.mota}</p>}
                        <div className="small text-muted mb-1">Số câu: {dethi.so_cau} · Tổng điểm: {dethi.tong_diem}</div>
                        <div className="small mb-3">
                            {savedAt
                                ? <span className="text-success"><span className="fas fa-cloud-upload-alt"></span> Đã lưu nháp lúc {fmtSavedAt(savedAt)}</span>
                                : <span className="text-muted">Bài làm tự động lưu nháp khi bạn thao tác.</span>}
                        </div>

                        {(dethi.list_cauhoi || []).map((c, idx) => (
                            <div className="border rounded p-3 mb-3" key={c.cauhoi_id}>
                                <div className="d-flex justify-content-between">
                                    <strong>Câu {idx + 1}</strong>
                                    <span className="badge badge-dark">{c.diem_hien_thi} điểm</span>
                                </div>
                                <div className="mt-1 mb-2" dangerouslySetInnerHTML={{ __html: c.title }} />
                                <CauHoiRenderer
                                    cauhoi={c}
                                    value={answers[c.cauhoi_id]}
                                    onChange={(v) => setAnswer(c.cauhoi_id, v)}
                                />
                            </div>
                        ))}

                        <div className="w-100 text-center mt-4">
                            <button type="button" className="btn-fill-lg btn-gradient-yellow btn-hover-bluedark" disabled={submitting} onClick={() => doSubmit(false)}>
                                {submitting ? <Spinner /> : <>Nộp bài</>}
                            </button>
                        </div>
                    </div>
                </div>
            }
        </AkkhorLayout>
    );
}
